import Tables from './index';

class TableInitializer {
  tableInit() {
    const tables = document.querySelectorAll('.rich-text-content > table');
    if (tables.length > 0) {
      const $tableModuleWrappers = [...tables];

      $tableModuleWrappers
        .map(($el) => {
          const instance = new Tables({ element: $el });
          instance.init();
          return $el;
        });
    }
    return null;
  }
}

export default TableInitializer;



// WEBPACK FOOTER //
// ./src/javascript/main/Tables/tableInitializer.js